import React, {useEffect, useRef, useState} from "react";
import "./bottomMenu.css";
import "./bottomsheet.css";
import {BottomSheet} from 'react-spring-bottom-sheet';

const BottomMenu = (
    {open = false, setOpen, filterContent = [], handleFilter = [{}], handleSubmitFilter, requiredDataOnChange,
        setIsRemoveFilter=() => {}, localstorageKeyRemove = '',smallSize=false}
) => {
    const [openDismiss, setOpenDismiss] = useState(false);

    function onDismiss(val) {
        if(localstorageKeyRemove){
            localStorage.removeItem(localstorageKeyRemove);
        }
        setOpenDismiss(val);
        setOpen(false)
        setIsRemoveFilter(true)
    }

    useEffect(() => {
        if (open) {
            setOpenDismiss(true)
        } else {
            setOpenDismiss(false)
        }
    }, [open])

    console.log("FILTER",filterContent)
    return (
        <>

            <BottomSheet
                open={openDismiss}
                //onDismiss={() => setOpen(false)}
                snapPoints={({maxHeight}) => 0.5 * maxHeight}
            >
                {/*<div className="col-md-12"><i onClick={() => onDismiss(false)} className="bi bi-x-square"></i></div>*/}
                <div className={`container mb-3 mt-20px d-mt-20px ${smallSize ? "row" : ""}`}>
                {smallSize==true &&
                    <div className="col-sm-12 col-md-12 d-flex mb-4">
                        <div className="col-sm-6 col-md-2">
                            <button className="btn btn-primary btn-user btn-block submit-btn submit-btn-2" onClick={() => onDismiss(false)}>
                                Go Back
                            </button>
                        </div>
                        <div className="col-sm-6 col-md-2">
                            <button className="btn btn-primary btn-user btn-block submit-btn submit-btn-2" onClick={handleSubmitFilter}>
                                Submit
                            </button>
                        </div>
                    </div>
                }
                {filterContent && filterContent !== undefined &&  filterContent !== [] && filterContent?.data !== undefined && filterContent?.data.map((val, key) => {
                    return (
                        <>
                            {val?.field === 'dropdown' ?
                                requiredDataOnChange !== undefined && requiredDataOnChange[0] !== undefined && requiredDataOnChange[0][val?.place_holder] !== undefined && requiredDataOnChange[0][val?.place_holder] !== "" ?
                                <div className={`${smallSize ? "col-sm-6 col-md-6" : "col-sm-12 col-md-12"} float-field ${val?.class} mb-2`}>
                                    <select className="form-control"
                                            onChange={(e) => {handleFilter(val?.place_holder.replaceAll(" ", "_").toLowerCase(), e.target.value, e.target.selectedOptions[0].text)}}
                                    >
                                        <option></option>
                                        {requiredDataOnChange[0][val?.place_holder].map((fieldValue, index) => {
                                            return (
                                                <option value={fieldValue?.id}>
                                                    {fieldValue?.name}
                                                </option>
                                            )
                                        })}
                                    </select>

                                    <label className="large-label float-lb">
                                        {val?.place_holder}
                                    </label>
                                </div> :
                                    <div className={`${smallSize ? "col-sm-6 col-md-6" : "col-sm-12 col-md-12"} float-field mb-2 ${val?.class}`}>
                                        <select className="form-control"
                                                onChange={(e) => {handleFilter(val?.place_holder.replaceAll(" ", "_").toLowerCase(), e.target.value, e.target.selectedOptions[0].text)}}
                                        >
                                            <option></option>
                                            {val?.values.map((fieldValue, index) => {
                                                return (
                                                    <>
                                                        {val?.selected && val?.selected === fieldValue?.id ?
                                                            <option value={fieldValue?.id} selected>
                                                                {fieldValue?.name}
                                                            </option>
                                                            :
                                                            <option value={fieldValue?.id}>
                                                                {fieldValue?.name}
                                                            </option>
                                                        }
                                                    </>
                                                )
                                            })}
                                        </select>

                                        <label className="large-label float-lb">
                                            {val?.place_holder}
                                        </label>
                                    </div> :
                                        <>
                                            {val?.field === 'date' &&
                                            <div className={`${smallSize ? "col-sm-6 col-md-6" : "col-sm-12 col-md-12"} float-field mb-4 ${val?.class}`}>
                                                    <input type="date"
                                                           className="form-control form-control-user"
                                                           placeholder=" "
                                                           onChange={(e) => {handleFilter(val?.place_holder.replaceAll(" ", "_").toLowerCase(), e.target.value)}}
                                                    />

                                                    <label className="large-label float-lb">
                                                        {val?.place_holder}
                                                    </label>
                                                </div>
                                            }
                                            {val?.field === 'text' &&
                                                <div className={`${smallSize ? "col-sm-6 col-md-6" : "col-sm-12 col-md-12"} float-field"`}>
                                                    <input type="text"
                                                           className="form-control form-control-user"
                                                           placeholder=" "
                                                           onChange={(e) => {handleFilter(val?.place_holder.replaceAll(" ", "_").toLowerCase(), e.target.value)}}
                                                    />

                                                    <label className="large-label float-lb">
                                                        {val?.place_holder}
                                                    </label>
                                                </div>
                                            }
                                        </>
                            }
                        </>
                    )
                })}
                {smallSize==false &&
                    <div className="col-sm-12 col-md-12 d-flex mb-4">
                        <div className="col-sm-6 col-md-2">
                            <button className="btn btn-primary btn-user btn-block submit-btn submit-btn-2" onClick={() => onDismiss(false)}>
                                Go Back
                            </button>
                        </div>
                        <div className="col-sm-6 col-md-2">
                            <button className="btn btn-primary btn-user btn-block submit-btn submit-btn-2" onClick={handleSubmitFilter}>
                                Submit
                            </button>
                        </div>
                    </div>
                }
                </div>
            </BottomSheet>
            {/* </div> */}


        </>
    );
}
export default BottomMenu;